<template>
  <div class="treeList">
    <el-popover
      ref="popover"
      :placement="placement"
      trigger="click"
      :disabled="disabled"
    >
      <el-tree
        :data="data"
        :props="props"
        node-key="nodeKey"
        ref="popupTree"
        @node-click="currentChangeHandle"
        :default-expand-all="defaultExpandAll"
        :highlight-current="true"
        :expand-on-click-node="true"
      >
      </el-tree>
    </el-popover>
    <el-input
      v-model="prop"
      v-popover:popover
      :placeholder="placeholder"
      style="cursor:pointer;"
      :disabled="disabled"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "PopupTreeInput",
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    props: {
      type: Object,
      default: function() {
        return {};
      }
    },
    prop: {
      type: String,
      default: ""
    },
    nodeKey: {
      type: String,
      default: ""
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    placement: {
      type: String,
      default: "right-start"
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    currentChangeHandle: {
      type: Function,
      default: null
    }
  }
};
</script>

<style scoped>
.el-tree {
  overflow: auto;
  height: 280px;
}
</style>
